import { render, staticRenderFns } from "./AdEdit.vue?vue&type=template&id=2c457a8d&scoped=true&"
import script from "./AdEdit.vue?vue&type=script&lang=js&"
export * from "./AdEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdEdit.vue?vue&type=style&index=0&id=2c457a8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c457a8d",
  null
  
)

export default component.exports